<template>
  <ShowViewForm insite="true" ref="showviewform" v-if="showViewFormData.list && showViewFormData.list.length > 0"
                :data="showViewFormData" :value="temp">
  </ShowViewForm>
</template>

<script>
import ShowViewForm from '@/components/Formcreated/components/ShowViewForm';
import * as forms from '@/api/forms';

export default {
  name: 'tx_quot_supplysview',
  components: { ShowViewForm },
  props: {
    commonObject: {
      type: Object,
      required: true
    },
    commonName: [String]
  },
  data() {
    return {
      temp: {},
      showViewFormData: {
        list: [],
        config: {}
      }
    };
  },
  watch: {
    commonObject: {
      deep: true,
      handler(val) {
        this.$refs.showviewform.reseltActiveName();
        this.InitDate();
      }
    }
  },
  created() {
    this.InitDate();
  },
  methods: {
    InitDate() {
      this.temp = { ...this.temp, ...this.commonObject };
      var queryObj = { SourceCode: 'Tx_Quot_Supply' };
      forms.getCreeateFrom(queryObj).then(response => {
        this.showViewFormData = response.result.contentData && JSON.parse(response.result.contentData) || {};
      }).catch(err => {
        console.log(err);
      });
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
